import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('PanoramaProvider');
export const PanoramaProvider = Provider;
export const PanoramaConsumer = Consumer;
export const PanoramaContext = Context;
export const usePanorama = useContext;
//# sourceMappingURL=PanoramaProvider.js.map